import React from 'react';
import { CalendarX } from 'lucide-react';
import '../styles/SegnoMancate.css';

/**
 * SegnoMancate — quante volte questo paziente non si e' presentato.
 *
 * DUE FORME PER DUE MOMENTI
 *   pallino  accanto al nome in un elenco di ricerca: costa uno sguardo,
 *            non interrompe niente, e chi non ha mai mancato non ha nulla
 *            accanto - la maggior parte degli elenchi resta pulita
 *   riga     nella finestra di prenotazione, sopra la soglia: una riga,
 *            non un popup. Un avviso che chiede un clic viene chiuso
 *            senza leggerlo dopo la seconda volta
 *
 * NIENTE ROSSO, NIENTE ICONA DI PERICOLO
 * E' un'informazione, non un'accusa. Un paziente che non si e' presentato
 * puo' aver avuto un ricovero o un lutto, e la schermata non lo sa.
 *
 * IL CONTEGGIO GUARDA DODICI MESI
 * Lo decide il database (vista pazienti_mancate). Qui si mostra e basta:
 * ripetere la finestra anche nel frontend vorrebbe dire due punti dove
 * cambiarla.
 */

// Sotto questa soglia la riga non compare: una singola assenza capita a
// tutti, e segnalarla insegna a ignorare l'avviso.
export const SOGLIA_AVVISO = 3;

const quando = (v) => {
    if (!v) return null;
    const d = new Date(v);
    return isNaN(d) ? null : d.toLocaleDateString('it-IT');
};

/** Il pallino accanto al nome. Non rende niente se il paziente e' pulito. */
export const PallinoMancate = ({ paziente }) => {
    const n = parseInt(paziente?.mancate_12m, 10) || 0;
    if (!n) return null;
    return (
        <span className={`sm-pallino ${n >= SOGLIA_AVVISO ? 'molte' : ''}`}
              title={`Non si è presentato ${n} ${n === 1 ? 'volta' : 'volte'} negli ultimi 12 mesi`}>
            <CalendarX size={11} strokeWidth={2.2} />
            {n}
        </span>
    );
};

/** La riga nella finestra di prenotazione. */
const SegnoMancate = ({ paziente, soglia = SOGLIA_AVVISO, onApri }) => {
    const n = parseInt(paziente?.mancate_12m, 10) || 0;
    if (n < soglia) return null;
    const ultima = quando(paziente.ultima_mancata);
    return (
        <div className="sm-riga">
            <CalendarX size={15} />
            <span>
                Non si è presentato <b>{n} volte</b> negli ultimi 12 mesi
                {ultima ? <> — l’ultima il {ultima}</> : null}.
            </span>
            {onApri && (
                <button type="button" onClick={onApri}>Vedi quando</button>
            )}
        </div>
    );
};

export default SegnoMancate;
